import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import { connect } from 'react-redux';
import STORE_KEY from '../../store/constants';
/** HoC that provides access to ecrionStore */

var connectExtended = function connectExtended(mapStateToProps, mapDispatchToProps, mergeProps) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return connect(mapStateToProps, mapDispatchToProps, mergeProps, _objectSpread({}, options, {
    storeKey: STORE_KEY
  }));
};

export default connectExtended;